import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { LPadrao } from "@/layouts"
  import { TProfissional } from "@/components/Profissionais"
  import { MenuItem } from "primevue/menuitem"
  import { useI18n } from "vue-i18n"
  import { shallowRef } from "vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ListaDeProfissionais',
  setup(__props) {

  const { t } = useI18n({ useScope: "global" })

  const breadCrumbItems: MenuItem[] = []
  const home: MenuItem = {
    label: t("profissionais"),
    icon: "pi pi-users",
    to: "/profissionais",
  }
  const info = shallowRef(t("umProfissionalRepresentaUmColaborador"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LPadrao), { class: "Profissionais" }, {
    default: _withCtx(() => [
      _createVNode(_unref(TProfissional), {
        "bread-crumb-items": breadCrumbItems,
        home: home,
        info: _unref(info)
      }, null, 8, ["info"])
    ]),
    _: 1
  }))
}
}

})